const getNotificationType = (type?: string) => {
  switch (type) {
    case 'DataSolutionsNotification':
      return 'dataSolutions';
    case 'ReachedTier':
      return 'loyaltyTier';
    case 'ReachedMilestone':
      return 'loyaltyMilestone';
    default:
      return 'normal';
  }
};

export default getNotificationType;
